export var SymphonySpacings;

(function (SymphonySpacings) {
  SymphonySpacings["nil"] = "nil";
  SymphonySpacings["tiny"] = "tiny";
  SymphonySpacings["small"] = "small";
  SymphonySpacings["medium"] = "medium";
  SymphonySpacings["large"] = "large";
  SymphonySpacings["big"] = "big";
  SymphonySpacings["huge"] = "huge";
})(SymphonySpacings || (SymphonySpacings = {}));

export var space = {
  nil: 0,
  tiny: 4,
  small: 8,
  medium: 16,
  large: 24,
  big: 32,
  huge: 40
};